import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Loader2 } from 'lucide-react'
import { getPlates } from '../api/brainer'

// Garage has no bespoke dashboard component (unlike EnergyOS's EnergyOSHomeownerDashboard) — its
// entire UI, including the landing page, is a Plate (see garage/src/services/plate-defs.ts's
// "Garage — Home"). This route's only job is resolving that Plate's id for the current business
// and redirecting to it within Garage's own workspace shell ("/garage/plates/:id", rendered by
// the generic PlateViewerPage — no Brainer builder chrome), since the id itself varies per
// business and can't be a static route.
export function GarageHome() {
  const navigate = useNavigate()
  const { data: plates, isLoading } = useQuery({
    queryKey: ['garage-home-plate'],
    queryFn: () => getPlates().then(r => r.data),
  })

  useEffect(() => {
    if (!plates) return
    const home = plates.find(p => p.name === 'Garage — Home')
    if (home) navigate(`/garage/plates/${home.id}`, { replace: true })
  }, [plates]) // eslint-disable-line react-hooks/exhaustive-deps

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-16">
        <Loader2 size={20} className="animate-spin text-ink-dim" />
      </div>
    )
  }

  if (plates && !plates.find(p => p.name === 'Garage — Home')) {
    return (
      <div className="p-8 text-center text-sm text-ink-dim">
        Garage isn't fully set up for this business yet — the "Garage — Home" plate hasn't been created.
      </div>
    )
  }

  return null
}
